import React from 'react'
import { useVehicle } from 'contexts'
import './style.css'
import ImageGallery from 'react-image-gallery'
import { useGetFilesUrls } from 'utils/hooks/queries'
import { useLoading } from 'utils/hooks'
import { isFileAPhoto, resolveDocumentsUrls, getDocumentsFileStorageIds } from 'utils/helpers'

const VehicleSheetSectionCarousel: React.FC<{
  isCarouselFull: boolean
  setIsCarouselFull: React.Dispatch<React.SetStateAction<boolean>>
}> = ({ isCarouselFull, setIsCarouselFull }) => {
  const vehicle = useVehicle()
  const { Loading } = useLoading()

  const photoDocuments = React.useMemo(
    () => vehicle.photos?.filter((doc) => isFileAPhoto(doc)) ?? [],
    [vehicle.photos],
  )

  const photoIds = getDocumentsFileStorageIds(photoDocuments)
  const hasPhotoIds = photoIds.length > 0

  const { idsAndUrls, isLoading } = useGetFilesUrls(photoIds)

  const resolvedPhotos = React.useMemo(
    () => resolveDocumentsUrls(photoDocuments, idsAndUrls),
    [photoDocuments, idsAndUrls],
  )

  const picturesArray = React.useMemo(
    () => resolvedPhotos.map(({ url }) => url).filter((url): url is string => Boolean(url)),
    [resolvedPhotos],
  )

  const hasAnyPhoto = picturesArray.length > 0
  const shouldDisplayLoader = hasPhotoIds && isLoading
  const [isCarouselFullScreen, setIsCarouselFullScreen] = React.useState(false)
  const [currentIndex, setCurrentIndex] = React.useState(0)
  const refGallery = React.useRef<ImageGallery | null>(null)

  if (shouldDisplayLoader) {
    return (
      <div className="vehicle-sheet__gallery-state">
        <Loading />
      </div>
    )
  }

  if (!hasAnyPhoto) {
    return (
      <div className="vehicle-sheet__gallery-state">
        Ce véhicule n&apos;a pas (encore) de photos
      </div>
    )
  }

  const setBool = (value: boolean) => {
    setIsCarouselFull(value)
  }
  const toggleCarouselFullScreen = () => {
    setIsCarouselFullScreen(!isCarouselFullScreen)
    setBool(!isCarouselFull)
  }

  const images = picturesArray.map((imgUrl: string) => ({
    original: imgUrl,
    thumbnail: imgUrl,
    originalClass: isCarouselFullScreen
      ? 'image-gallery-slide-fullScreen'
      : 'image-gallery-slide-smallScreen',
  }))

  const upDateIndex = () => {
    setCurrentIndex(refGallery.current?.getCurrentIndex() ?? 0)
  }
  const handleScreenChange = () => {
    upDateIndex()
    toggleCarouselFullScreen()
  }

  const handleClick = () => {
    upDateIndex()
    window.open(picturesArray[currentIndex], '_blank')
  }

  return (
    <ImageGallery
      items={images}
      useBrowserFullscreen={false}
      showPlayButton={false}
      onScreenChange={handleScreenChange}
      ref={refGallery}
      showIndex
      startIndex={currentIndex}
      onClick={handleClick}
      onMouseOver={upDateIndex}
    />
  )
}

export default VehicleSheetSectionCarousel
